var map = {
	"./img_banner_project1_0.jpg": "1684",
	"./img_banner_project1_1.jpg": "509d",
	"./img_banner_project1_2.jpg": "48b5",
	"./img_banner_project1_3.jpg": "afab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d05e";